import { render, staticRenderFns } from "./ShowGr.vue?vue&type=template&id=79289971&scoped=true&"
import script from "./ShowGr.vue?vue&type=script&lang=js&"
export * from "./ShowGr.vue?vue&type=script&lang=js&"
import style0 from "./ShowGr.vue?vue&type=style&index=0&id=79289971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79289971",
  null
  
)

component.options.__file = "ShowGr.vue"
export default component.exports